import { render, staticRenderFns } from "./create_survey_component.vue?vue&type=template&id=274f66fc&scoped=true"
import script from "./create_survey_component.vue?vue&type=script&lang=js"
export * from "./create_survey_component.vue?vue&type=script&lang=js"
import style0 from "./create_survey_component.vue?vue&type=style&index=0&id=274f66fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f66fc",
  null
  
)

export default component.exports